import React, { useState, useEffect, useRef } from 'react';
import api, { getUploadUrl } from '../../services/api';

const empty = { nome: '', descricao: '', pontuacao_necessaria: '', estoque: '' };

export default function AdminPremiacoes() {
  const [premiacoes, setPremiacoes] = useState([]);
  const [form, setForm] = useState(empty);
  const [editando, setEditando] = useState(null);
  const [imagemFile, setImagemFile] = useState(null);
  const [imagemPreview, setImagemPreview] = useState(null);
  const [msg, setMsg] = useState('');
  const fileRef = useRef(null);

  useEffect(() => { carregar(); }, []);
  function carregar() { api.get('/premiacoes/admin').then(setPremiacoes).catch(() => {}); }

  function set(field) { return e => setForm(f => ({ ...f, [field]: e.target.value })); }

  function handleImagem(e) {
    const file = e.target.files[0];
    if (!file) return;
    setImagemFile(file);
    setImagemPreview(URL.createObjectURL(file));
  }

  function limparImagem() {
    setImagemFile(null);
    setImagemPreview(null);
    if (fileRef.current) fileRef.current.value = '';
  }

  async function salvar(e) {
    e.preventDefault(); setMsg('');
    try {
      const fd = new FormData();
      fd.append('nome', form.nome);
      fd.append('descricao', form.descricao);
      fd.append('pontuacao_necessaria', form.pontuacao_necessaria);
      fd.append('estoque', form.estoque !== '' ? form.estoque : '');
      if (imagemFile) fd.append('imagem', imagemFile);

      if (editando) {
        fd.append('ativo', editando.ativo ? '1' : '0');
        await api.uploadPut(`/premiacoes/${editando.id}`, fd);
      } else {
        await api.upload('/premiacoes', fd);
      }
      setMsg('Salvo com sucesso!');
      setForm(empty); setEditando(null); limparImagem(); carregar();
    } catch (err) { setMsg(err.message); }
  }

  async function deletar(id) {
    if (!window.confirm('Remover premiação?')) return;
    await api.delete(`/premiacoes/${id}`); carregar();
  }

  function iniciarEdicao(p) {
    setEditando(p);
    setForm({
      nome: p.nome,
      descricao: p.descricao || '',
      pontuacao_necessaria: p.pontuacao_necessaria,
      estoque: p.estoque != null ? p.estoque : '',
    });
    limparImagem();
  }

  function cancelar() {
    setEditando(null);
    setForm(empty);
    limparImagem();
  }

  const previewSrc = imagemPreview || (editando?.imagem ? getUploadUrl(editando.imagem) : null);

  return (
    <div>
      <h2 className="admin-title">Premiações</h2>
      {msg && <div className="alert alert-success">{msg}</div>}
      <form onSubmit={salvar} className="admin-form">
        <h3>{editando ? 'Editar Premiação' : 'Nova Premiação'}</h3>
        <div className="form-row">
          <div className="form-group">
            <label>Nome</label>
            <input value={form.nome} onChange={set('nome')} required />
          </div>
          <div className="form-group">
            <label>Pontos Necessários</label>
            <input type="number" min="1" value={form.pontuacao_necessaria} onChange={set('pontuacao_necessaria')} required />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Estoque Disponível</label>
            <input
              type="number" min="0"
              value={form.estoque}
              onChange={set('estoque')}
              placeholder="Deixe em branco para ilimitado"
            />
          </div>
        </div>
        <div className="form-group">
          <label>Descrição</label>
          <textarea value={form.descricao} onChange={set('descricao')} rows={2} />
        </div>
        <div className="form-group">
          <label>Foto do Prêmio</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            {previewSrc && (
              <img
                src={previewSrc}
                alt="Prévia"
                style={{ width: 64, height: 64, objectFit: 'cover', borderRadius: 8, border: '1px solid var(--border)', flexShrink: 0 }}
              />
            )}
            <input ref={fileRef} type="file" accept="image/*" onChange={handleImagem} style={{ flex: 1 }} />
          </div>
          {imagemFile && (
            <button type="button" onClick={limparImagem} style={{ marginTop: 6, fontSize: 12, color: 'var(--danger)', background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
              ✕ Remover imagem selecionada
            </button>
          )}
        </div>
        <div className="admin-actions">
          <button type="submit" className="btn btn-primary">Salvar</button>
          {editando && (
            <button type="button" className="btn btn-secondary" onClick={cancelar}>
              Cancelar
            </button>
          )}
        </div>
      </form>
      <div className="admin-table-wrap">
        <table>
          <thead>
            <tr><th>Foto</th><th>Nome</th><th>Pontos</th><th>Estoque</th><th>Ativo</th><th>Ações</th></tr>
          </thead>
          <tbody>
            {premiacoes.map(p => (
              <tr key={p.id}>
                <td>
                  {p.imagem
                    ? <img src={getUploadUrl(p.imagem)} alt={p.nome} style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 6 }} />
                    : <span style={{ fontSize: 22 }}>🎁</span>
                  }
                </td>
                <td>{p.nome}</td>
                <td>{p.pontuacao_necessaria}</td>
                <td>
                  {p.estoque === null || p.estoque === undefined
                    ? <span style={{ color: 'var(--text2)', fontSize: 12 }}>Ilimitado</span>
                    : p.estoque === 0
                      ? <span className="badge badge-danger">Esgotado</span>
                      : <span className="badge badge-success">{p.estoque} un.</span>
                  }
                </td>
                <td>{p.ativo ? <span className="badge badge-success">Sim</span> : <span className="badge badge-danger">Não</span>}</td>
                <td>
                  <div className="admin-actions">
                    <button className="btn btn-secondary" onClick={() => iniciarEdicao(p)}>Editar</button>
                    <button className="btn btn-danger" onClick={() => deletar(p.id)}>Remover</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
